import { render, staticRenderFns } from "./RoomCardShimmer.vue?vue&type=template&id=5c2df68e&scoped=true&"
import script from "./RoomCardShimmer.vue?vue&type=script&lang=js&"
export * from "./RoomCardShimmer.vue?vue&type=script&lang=js&"
import style0 from "./RoomCardShimmer.vue?vue&type=style&index=0&id=5c2df68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2df68e",
  null
  
)

export default component.exports